import { useEffect, type ReactElement } from "react";
import { Trans } from "react-i18next";
import { Notice } from "components/notice";
import { Text } from "components/text";
import { useAnalytics } from "contexts/AnalyticsContext";
import type { SeasonalEventSurface } from "contexts/AnalyticsContext/AnalyticsEvents";

interface SemanticSearchNoticeProps {
  surface: SeasonalEventSurface;
}

export const SemanticSearchNotice = ({
  surface,
}: SemanticSearchNoticeProps): ReactElement => {
  const { gaEvent } = useAnalytics();

  useEffect(() => {
    gaEvent({
      type: "semantic_info_viewed",
      payload: { surface },
    });
  }, [gaEvent, surface]);

  return (
    <Notice variant="info">
      <Trans
        i18nKey="components:seasonalEventModal.semanticInfo"
        components={{
          strong: <Text as="strong" variant="bodyStrong" />,
        }}
      />
    </Notice>
  );
};
